export default "__VITE_ASSET__4CqsonhX__"